import React from 'react';
import Icon, { Size } from 'components/general/icon/icon';
import Button from 'lj_shared/button/button';

const styles = require('./job_search_cta.module.scss');

interface Props {
  averageLow: number;
  categorySlug: string;
  jobsBySalaryCount: number;
}

export default function JobSearchCta(props: Props) {
  const { averageLow, categorySlug, jobsBySalaryCount } = props;
  const averageLowString = (averageLow * 1000).toLocaleString().replace(',', '.');
  const jobSearchUrl = window.Routes.search_job_ads({
    min_salary: averageLow * 1000,
    currency: 'EUR',
    category: [categorySlug],
  });

  return (
    <div className={styles.container}>
      <Icon name={'warningCodeInfo'} size={Size.BigHero} />
      <div className={styles.containerRight}>
        <div className={styles.containerText}>
          We currently have&nbsp;
          <span className={styles.bold}>{jobsBySalaryCount} jobs </span>
          with&nbsp;
          <span className={styles.bold}>
            {averageLowString}€ of minimum salary in your job category.
          </span>
        </div>
        <Button buttonColor='tuftsBlue' isButton={false} isRound={true} buttonUrl={jobSearchUrl}>
          Check these jobs
        </Button>
      </div>
    </div>
  );
}
